import { IChatSource } from 'interfaces/components/chatbot/chatbot';
import { processBase64Image } from 'utils/helpers/chatbotApi';

interface IChatSourcesProps {
  sources: IChatSource[];
}

const ChatSources = ({ sources }: IChatSourcesProps) => {
  if (!sources || sources.length === 0) return null;

  return (
    <div>
      <h4 className='text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2'>
        Sources:
      </h4>
      <div className='flex flex-col gap-2'>
        {sources.map((source) => {
          const sourceKey = `${source.FILE_NAME}-${source.PAGE_NUM}`;
          const hasPageNumber =
            typeof source.PAGE_NUM === 'string' && source.PAGE_NUM.trim().length > 0;
          const displayName = hasPageNumber
            ? `${source.FILE_NAME} (page ${source.PAGE_NUM})`
            : source.FILE_NAME;
          
          return (
            <div
              key={sourceKey}
              className='flex flex-col gap-3 p-2 bg-gray-50 dark:bg-gray-700 rounded border border-gray-200 dark:border-gray-500'
            >
              {source.FILE_NAME && (
                source.FILE_URL ? (
                  <a
                    href={source.FILE_URL}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-sm font-medium text-gray-900 dark:text-gray-100 underline break-words hover:text-green-600 dark:hover:text-green-400 transition-colors'
                  >
                    {displayName}
                  </a>
                ) : (
                  <p className='text-sm font-medium text-gray-900 dark:text-gray-100'>
                    {displayName}
                  </p>
                )
              )}
              {source.FILE_IMAGE && (
                <div>
                  <img
                    src={processBase64Image(source.FILE_IMAGE)}
                    alt={`Source: ${source.FILE_NAME || 'Document'}`}
                    className='max-w-full h-auto object-cover rounded border border-gray-200 dark:border-gray-600'
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      console.warn('Failed to load source image:', source.FILE_NAME);
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ChatSources;
